// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import {useContextState as useUserContext} from '../../../../../context/user';
import {useSalesmanContext} from '../../../../../context/salesman';
import {Role} from '../../../../../constants/enumerations';
import useClientContext from '../../../../../context/client/Context';

export const usePortfolioFilterHook = () => {
  const {uiConfiguration, profile} = useUserContext();
  const {
    salesCategories,
    salesCities,
    salesmanProductList,
    salesTerritories,
    fetchSalesmanProducts,
    setPortfolioFilter: setSalesmanPortfolioFilter,
    salesmanPortfolioFilter,
  } = useSalesmanContext();

  const {
    setClientPortfolioFilter,
    clientPortfolioFilter,
    fetchClientProducts,
    clientCategories,
    clientCities,
    clientProductList,
    clientTerritories,
  } = useClientContext();

  const isSalesman = () => profile?.role === Role.salesman;

  const categoryList = isSalesman() ? salesCategories : clientCategories;
  const cityList = isSalesman() ? salesCities : clientCities;
  const productList = isSalesman() ? salesmanProductList : clientProductList;
  const territoryList = isSalesman() ? salesTerritories : clientTerritories;
  const fetchProducts = isSalesman()
    ? fetchSalesmanProducts
    : fetchClientProducts;
  const setFilter = isSalesman()
    ? setSalesmanPortfolioFilter
    : setClientPortfolioFilter;
  const filter = isSalesman() ? salesmanPortfolioFilter : clientPortfolioFilter;

  const getGoBackScreen = ():
    | 'SalesmanPortfolioDashboard'
    | 'DashboardClient' => {
    return isSalesman() ? 'SalesmanPortfolioDashboard' : 'DashboardClient';
  };

  return {
    categoryList,
    cityList,
    productList,
    territoryList,
    fetchProducts,
    setFilter,
    filter,
    uiConfiguration,
    getGoBackScreen,
  };
};
